import { useQuery } from '@apollo/client';

import { GetClientStatusOverviewDocument } from './graphql/clientStatusOverview.gql';

export const useGetClientStatusOverview = (clientId: string) => {
  const { data, ...rest } = useQuery(GetClientStatusOverviewDocument, {
    variables: { clientId },
  });

  return {
    statusOverview: data?.client?.statusOverview,
    ...rest,
  };
};

export const refetchGetClientStatusOverview = (clientId: string) => ({
  query: GetClientStatusOverviewDocument,
  variables: { clientId },
});
